import { render, staticRenderFns } from "./SpoiledDropZone.vue?vue&type=template&id=5a5da9a0&scoped=true&"
import script from "./SpoiledDropZone.vue?vue&type=script&lang=js&"
export * from "./SpoiledDropZone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5da9a0",
  null
  
)

export default component.exports